import { Api } from "../config/request";

export default {
  getScheduledNotificationsList(payload) {
    return Api.post(`/notification_campaigns`, payload);
  },
  getActiveCampaign(campaign_id, lang_id = "") {
    if (lang_id == "") {
      return Api.get(`/notification_campaign?id=${campaign_id}`);
    }
    return Api.get(`/notification_campaign?id=${campaign_id}&lang=${lang_id}`);
  },
  getNewCampaignOptions() {
    return Api.get(`/notification_campaign_options`);
  },
  driverSelectionCSVUpload(payload) {
    return Api.post("/notification_campaign/upload_csv", payload);
  },
  uploadCampaignImage(payload) {
    return Api.post("/notification_campaign/upload_image", payload);
  },
  createCampaign(payload) {
    return Api.post("/notification_campaign/create_campaign", payload);
  },
  editCampaign(payload) {
    return Api.post("/notification_campaign/edit_campaign", payload);
  }
};
